import React from 'react'

const LanguageContext = React.createContext({
  language: 'id',
  setLanguage: () => {}
})

export default LanguageContext